(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6835],{

/***/ 26835:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(305);
/* harmony import */ var _Breadcrumbs_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92678);
/* harmony import */ var _Breadcrumbs_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Breadcrumbs_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var Breadcrumbs = function(param) {
    var items = param.items, children = param.children;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_Breadcrumbs_module_scss__WEBPACK_IMPORTED_MODULE_2___default().container),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                className: (_Breadcrumbs_module_scss__WEBPACK_IMPORTED_MODULE_2___default().breadcrumb),
                children: items.map(function(v, idx) {
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        className: (_Breadcrumbs_module_scss__WEBPACK_IMPORTED_MODULE_2___default().item),
                        children: (v === null || v === void 0 ? void 0 : v.to) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            to: v === null || v === void 0 ? void 0 : v.to,
                            children: v.text
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: v.text
                        })
                    }, idx);
                })
            }),
            children
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Breadcrumbs);


/***/ }),

/***/ 92678:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Breadcrumbs_container__oeQ5p","breadcrumb":"Breadcrumbs_breadcrumb__XjKH5","item":"Breadcrumbs_item__3itB_"};

/***/ })

}]);